const constants = {
    apiHome : 'https://vercel-niranjan-kumar-k-s-s-projects.vercel.app/password-manager',
    dbUserAuthHashMaker : 'ShriRamaChandra1008ShriRamaBadra'
};

export default constants;